import UserObject from "../../../../src/mdx/api/schema/user-object.mdx";
import * as React from 'react';
export default {
  UserObject,
  React
};